import validate from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.8_@azure+identity@4.13.0_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@_00b3dff35a68ba611337aee823d6f564/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.4.8_@azure+identity@4.13.0_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@_00b3dff35a68ba611337aee823d6f564/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-auth": () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/check-auth.ts"),
  "migrate-product-formats": () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/migrate-product-formats.ts")
}